import { defineStore } from 'pinia'
import { StoreId } from '@/store'
import { ChangeState } from '@/store/basket/basket.types'
import { Success } from '@/api/results'
import { ChangeChoices } from '@/types/api/api-v3/basket'

export const useBasketChangeStore = defineStore(StoreId.BASKET_CHANGE, {
  state: (): ChangeState => {
    return {
      choices: [],
      quantitySelectedProducts: {},
    }
  },
  getters: {
    getQuantitySelectedProducts:
      ({ quantitySelectedProducts }) =>
      (productId: number) => {
        return +quantitySelectedProducts[productId] || 0
      },
  },
  actions: {
    setQuantitySelectedProducts(data: { index: number; value: number }) {
      if (data.value === 0) {
        delete this.quantitySelectedProducts[data.index]
        return
      }

      this.quantitySelectedProducts[data.index] = data.value
    },

    resetSelectedProducts() {
      for (const id in this.quantitySelectedProducts) {
        delete this.quantitySelectedProducts[id]
      }
    },

    async fetchChange(amount: number) {
      const { $apiService } = useNuxtApp()
      const result = await $apiService.basket.fetchChange(amount)

      if (result instanceof Success) {
        this.setChange(result.data || [])

        return result
      }
    },

    setChange(changeList: ChangeChoices[]) {
      this.choices = changeList
    },
  },
})
